<template>
  <TheMainContent>
    <RevContainer class="my-40">
      <RevCard class="p-24">
        <RevContentBlock
          :button-disabled="props.disabled"
          :button-label="i18n(props.translations.cta)"
          :button-loading="props.loading"
          :has-rounded-image="true"
          :image-left="true"
          :image-props="IMAGE_PROPS"
          :title="i18n(props.translations.title)"
          title-tag="h1"
          @click="emit('click')"
        >
          {{ i18n(props.translations.content) }}
        </RevContentBlock>
      </RevCard>
    </RevContainer>
  </TheMainContent>
</template>

<script lang="ts" setup>
import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types/i18n'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevContainer } from '@ds/components/Container'
import { RevContentBlock } from '@ds/components/ContentBlock'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'

type ResendLinkTranslations = {
  title: I18nDefinition
  content: I18nDefinition
  cta: I18nDefinition
}

const props = defineProps<{
  translations: ResendLinkTranslations
  disabled?: boolean
  loading?: boolean
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()

const i18n = useI18n()

const IMAGE_PROPS = {
  alt: '',
  height: 1333,
  width: 2000,
  src: '/img/guest/expired-link.jpg',
} as const
</script>
